/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * feedRoutes
 * ----------
 * Where the athlete feed lives, and how the old /dashboard URLs map onto it.
 *
 * Non-organizer users no longer get the table-based Dashboard. Rather than
 * editing every place that still links or redirects to /dashboard (sign-in,
 * SSO callback, Banner, the notification bell's "view" action), the Dashboard
 * route redirects them here through dashboardToFeed(). Pages that moved keep
 * their meaning — /dashboard/profile opens /feed/profile — and everything that
 * has no athlete equivalent (tables, exports, settings) lands on the feed.
 */

export const FEED_PATH = '/feed';
export const FEED_PROFILE_PATH = '/feed/profile';
export const FEED_NOTIFICATIONS_PATH = '/feed/notifications';
export const FEED_ANALYTICS_PATH = '/feed/analytics';
/** My certificates; the email link /certificate/<id> lands here with ?c=<id>. */
export const FEED_CERTIFICATES_PATH = '/feed/certificates';
/** My payments — the buyer's own payment history. */
export const FEED_PAYMENTS_PATH = '/feed/payments';
export const CERTIFICATE_LINK_PATH = '/certificate/:certificateId';
export const EVENTS_PATH = '/p/event';
export const REGISTRATIONS_PATH = '/app/my-registrations';

/*
 * Phone/tablet copies of the two pages above. Events and Registrations are
 * portal pages with chrome of their own, so on a narrow screen — where the
 * feed shows its own top bar and bottom tabs — following the links above
 * replaced the whole shell and showed a second header. These routes render
 * the very same pages inside the feed's middle column instead; on a wide
 * screen the nav keeps pointing at the portal paths and nothing changes.
 */
export const FEED_EVENTS_PATH = '/feed/events';
export const FEED_PASSES_PATH = '/feed/passes';

/** The table slug behind EVENTS_PATH ('/p/event' -> 'event'). */
export const EVENTS_SLUG = EVENTS_PATH.replace(/^\/p\//, '');
/** The Page Builder slug behind REGISTRATIONS_PATH ('/app/my-registrations' -> 'my-registrations'). */
export const REGISTRATIONS_SLUG = REGISTRATIONS_PATH.replace(/^\/app\//, '');

export const activityPath = (id) => `${FEED_PATH}/activity/${encodeURIComponent(id)}`;

const MOVED = {
  '/dashboard/profile': FEED_PROFILE_PATH,
  '/dashboard/notifications': FEED_NOTIFICATIONS_PATH,
};

/** A /dashboard path (and its query string) → the /feed path that replaces it. */
export function dashboardToFeed(pathname = '', search = '') {
  const clean = String(pathname).replace(/\/+$/, '') || '/dashboard';
  const target = MOVED[clean];
  return target ? `${target}${search || ''}` : FEED_PATH;
}
